import {interval, Observable, ReplaySubject, startWith, switchMap} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {CommonObject} from '../model/common-object';

export class CurrentSubject<T> extends ReplaySubject<T> {
  value: T;

  set(value?: T): void {
    this.value = value;
    this.next(value);
  }
}

export class CommonService<C extends CommonObject> {
  protected objects: C[];
  protected subject = new CurrentSubject<C[]>();

  constructor(protected http: HttpClient, protected url: string, protected repeat: boolean = false) {
    if(repeat) {
      interval(5 * 60 * 1000) // 5 minutes * 60 seconds * 1000 milliseconds
        .pipe(
          startWith(0), // Emit immediately
          switchMap(() => this.http.get<C[]>(`${environment.backend}${url}`))
        )
        .subscribe(data => {
          this.objects = this.sort(data);
          this.subject.next(this.sort(this.objects));
        }, error => {
          this.subject.error(error);
        });
    } else {
      this.http.get<C[]>(`${environment.backend}${url}`).subscribe(data => {
        this.objects = this.sort(data);
        this.subject.next(this.sort(this.objects));
      }, error => {
        this.subject.error(error);
      });
    }
  }

  getObjects(): Observable<C[]> {
    return this.subject.asObservable();
  }

  createObject(obj: C): void {
    this.http.post<C>(`${environment.backend}${this.url}`, obj).subscribe(data => {
      let exists = false;
      if (obj.id !== undefined) {
        this.objects = this.objects.map(d => {
          if (d.id === obj.id) {
            exists = true;
            return data;
          }
          return d;
        });
      }
      if (!exists) {
        this.objects.unshift(data);
      }
      this.subject.next(this.sort(this.objects));
    });
  }

  deleteObject(obj: C): void {
    this.http.delete(`${environment.backend}${this.url}/${obj.id}`).subscribe(() => {
      this.objects = this.objects.filter(data => {
        return data.id !== obj.id;
      });
      this.subject.next(this.sort(this.objects));
    });
  }

  sort(objs: C[]): C[] {
    return objs;
  }
}
